import { NavLink, useLocation } from "react-router-dom";
import { MonitorPlay, ListTodo, ShoppingCart, PackageCheck, Menu } from "lucide-react";

/**
 * Die Leiste unten auf dem Handy - fuenf Ziele, mit dem Daumen erreichbar.
 *
 * Wallboard und Bestellungen sind das, wofuer die App auf dem Telefon da ist
 * (Ansage Franklin, 24.09.2026); sie stehen deshalb links und rechts der
 * Mitte, in der Mitte der Bestell-Knopf mit der Kamera. Aufgaben daneben,
 * weil sie vom Wallboard kommen. "Mehr" oeffnet das ganze Menue - alles
 * andere geht auch, nur nicht mit einem Tipp.
 *
 * Die Zahlen sind dieselben wie im Menue links (menue-zaehler): offene
 * Freigaben bei Bestellungen, faellige eigene Aufgaben bei Aufgaben.
 */
function Zahl({ wert }) {
  if (!wert) return null;
  return (
    <span data-testid="leiste-zaehler"
          className="absolute -top-1 right-1/2 translate-x-4 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600
                     text-[10px] font-bold text-white flex items-center justify-center tabular leading-none ring-2 ring-white">
      {wert > 99 ? "99+" : wert}
    </span>
  );
}

function Ziel({ to, icon: Icon, label, zahl, testid, aktivWenn }) {
  const { pathname } = useLocation();
  const aktiv = aktivWenn ? aktivWenn(pathname) : (pathname === to || pathname.startsWith(to + "/"));
  return (
    <NavLink to={to} data-testid={testid} aria-current={aktiv ? "page" : undefined}
             className={`relative flex-1 h-full flex flex-col items-center justify-center gap-0.5 select-none
                         ${aktiv ? "text-marke-navy" : "text-slate-500"} active:text-marke-navy`}>
      <span className={`h-7 w-11 rounded-full flex items-center justify-center transition-colors ${aktiv ? "bg-marke-blau-tint text-marke-blau-text" : ""}`}>
        <Icon className="h-[22px] w-[22px]" strokeWidth={aktiv ? 2.4 : 2} />
      </span>
      <span className={`text-[10.5px] leading-none ${aktiv ? "font-semibold" : "font-medium"}`}>{label}</span>
      <Zahl wert={zahl} />
    </NavLink>
  );
}

export default function HandyLeiste({ zaehler = {}, onBestellen, onMehr, verborgen = false }) {
  const { pathname } = useLocation();
  const imBestellen = pathname.startsWith("/bestellen/");
  return (
    <nav data-testid="handy-leiste"
         className={`md:hidden fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur
                     pb-[env(safe-area-inset-bottom)] ${verborgen ? "hidden" : ""}`}>
      <div className="h-16 flex items-stretch">
        <Ziel to="/tafel" icon={MonitorPlay} label="Wallboard" testid="leiste-tafel"
              aktivWenn={(p) => p === "/tafel" || p === "/"} />
        <Ziel to="/aufgaben-kundenservice" icon={ListTodo} label="Aufgaben" testid="leiste-aufgaben"
              zahl={zaehler.aufgaben_service} />
        {/* Der Bestell-Knopf: erhaben, in der Mitte, oeffnet das Blatt mit den Lieferanten. */}
        <button type="button" onClick={onBestellen} data-testid="leiste-bestellen" aria-label="Ware bestellen"
                className="relative flex-1 flex flex-col items-center justify-end pb-1.5 select-none text-slate-500 active:text-slate-900">
          <span className={`absolute -top-4 h-14 w-14 rounded-full shadow-lg flex items-center justify-center ring-4 ring-slate-50
                            ${imBestellen ? "bg-marke-navy-2" : "bg-marke-navy"} text-white`}>
            <ShoppingCart className="h-6 w-6" />
          </span>
          <span className="text-[10.5px] leading-none font-semibold text-marke-navy">Bestellen</span>
        </button>
        <Ziel to="/bestellungen" icon={PackageCheck} label="Bestellungen" testid="leiste-bestellungen"
              zahl={zaehler.bestellungen} />
        <button type="button" onClick={onMehr} data-testid="leiste-mehr"
                className="relative flex-1 h-full flex flex-col items-center justify-center gap-0.5 select-none text-slate-500 active:text-slate-900">
          <span className="h-7 w-11 rounded-full flex items-center justify-center">
            <Menu className="h-[22px] w-[22px]" />
          </span>
          <span className="text-[10.5px] leading-none font-medium">Mehr</span>
        </button>
      </div>
    </nav>
  );
}
